/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { RadioGroupField, RadioOption } from 'components/form'
import { useFlags } from 'config/useFlagsContext'
import { FichaComplementarZikaMicrocefaliaResultadoExameEnum } from 'graphql/types.generated'

import { FactoryResultadoExameEspecificoFieldProps } from '../../model-resultadosExames'
import {
  getResultadoExameEspecificoProperties,
  getResultadoExameEspecificoPuericulturaLabel,
} from '../../util-resultadosExames'

export const ResultadoExamePuericulturaField = (props: FactoryResultadoExameEspecificoFieldProps) => {
  const { name, exame } = props

  const { PILOTO_CASA_DECIMAL_RESULTADO_EXAME_ENABLED } = useFlags()

  const { options } = getResultadoExameEspecificoProperties(exame, PILOTO_CASA_DECIMAL_RESULTADO_EXAME_ENABLED)

  return (
    <RadioGroupField
      name={name}
      options={convertEnumsToRadioOptions(options as FichaComplementarZikaMicrocefaliaResultadoExameEnum[])}
      style={{
        hFlow: css`
          padding-top: 0;
        `,
      }}
      clearable
    />
  )
}

const convertEnumsToRadioOptions = (
  values: FichaComplementarZikaMicrocefaliaResultadoExameEnum[]
): RadioOption<FichaComplementarZikaMicrocefaliaResultadoExameEnum>[] =>
  values.map((value) => ({ value, label: getResultadoExameEspecificoPuericulturaLabel(value) }))
